import { Tag } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { BseBidStatusDto } from "../../../autogen/bff-api";

export const BidInvitationStatus = ({ status }: { status: BseBidStatusDto }) => {
  const { t } = useTranslation();

  const getTagMeta = (status: BseBidStatusDto): { color: string; text: string } => {
    switch (status) {
      case BseBidStatusDto.DeadlinePassedAndBidDelivered:
      case BseBidStatusDto.BidDelivered:
        return {
          color: "blue",
          text: t("Delivered"),
        };
      case BseBidStatusDto.DraftCreated:
        return {
          color: "yellow",
          text: t("Draft"),
        };
      case BseBidStatusDto.InviteAccepted:
      case BseBidStatusDto.InviteNotAccepted:
        return {
          color: "gray",
          text: t("Invited"),
        };
      case BseBidStatusDto.DeadlinePassedWithoutBidDelivered:
        return {
          color: "red",
          text: t("Overdue"),
        };
      case BseBidStatusDto.IsLoser:
        return {
          color: "red",
          text: t("Loser"),
        };
      case BseBidStatusDto.IsWinner:
        return {
          color: "green",
          text: t("Winner!"),
        };
      case BseBidStatusDto.InviteDeclined:
        return {
          color: "red",
          text: t("Declined"),
        };
      case BseBidStatusDto.EventCancelledAndBidDelivered:
      case BseBidStatusDto.EventCancelledWithoutBidDelivered:
        return {
          color: "gray",
          text: t("Cancelled"),
        };
      case BseBidStatusDto.EventClosedAndBidDelivered:
        return {
          color: "blue",
          text: t("Completed"),
        };
      case BseBidStatusDto.EventClosedWithoutBidDelivered:
        return {
          color: "gray",
          text: t("Completed"),
        };
    }
  };

  const tagMeta = getTagMeta(status);

  return (
    <>
      <Tag size="sm" variant="outline" colorScheme={tagMeta.color} textAlign="center" py="1">
        {tagMeta.text}
      </Tag>
    </>
  );
};
